var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"flat":"","max-height":"65"}},[_c('Header')],1),_c('router-view'),_c('v-footer',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }